import React, { Component } from "react";

import { reduxForm, Field, change } from 'redux-form';
import { connect } from 'react-redux';

//material ui components
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';

//actions
import { getResidentsByCommunity } from '../../actions/residentActions';
import {
    AddDevice,
    UnregisterResidents
} from '../../actions/deviceActions';

//Engage Components
import {
    renderLegacyTextField,
    LegacyRenderSelectV2
} from '../../utils/engageComponents';

//menuItems

class LModalUnregister extends Component {
    constructor(props) {
        super();
        this.state = {
            open: false,
            //Resize
            rootFontSize: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 970,
            },
        };

    }

    componentDidMount() {
        if (this.props.isRegister)
            this.props.getResidentsByCommunity(this.props.communityInfo._id);
    }

    componentWillMount() {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        this.setState({ isMobile: window.innerWidth <= 960 });

        const sizes = {
            xs: {
                name: 'xs',
                fontSize: '58%',
                maxWidht: 600,
            },
            sm: {
                name: 'sm',
                fontSize: '60%',
                maxWidht: 1024,
            },
            md: {
                name: 'md',
                fontSize: '80%',
                maxWidht: 1880,
            },
            lg: {
                name: 'lg',
                fontSize: '100%',
                maxWidht: 1920,
            },
        };

        const windowWidht = window.innerWidth;
        const windowHeiht = window.innerHeight;

        let rootFontSize = sizes.xs;

        if (windowWidht > sizes.md.maxWidht) {
            rootFontSize = sizes.lg;
        } else if (windowWidht > sizes.sm.maxWidht) {
            rootFontSize = sizes.md;
        } else if (windowWidht > sizes.xs.maxWidht) {
            rootFontSize = sizes.sm;
        } else {
            rootFontSize = sizes.xs;
        }


        this.setState({
            rootFontSize: rootFontSize,
            windowWidht: windowWidht,
            windowHeiht: windowHeiht,
        });
    }

    //#region  Inner components


    CheckForValidCaracters = (input) => {
        let pattern = '[0-9]';

        if (input.length > 6) {
            return input.substring(0, input.length - 1);
        }

        if (input.length > 0) {
            var regex = new RegExp(pattern);
            if (regex.test(input)) {
                return input;
            } else {
                return input.substring(0, input.length - 1);
            }
        } else {
            return input;
        }

    };

    async onSubmitHandler(formData) {
        const newDevice = {}
        newDevice.communityId = localStorage.getItem('communityId');
        newDevice.registrationcode = this.state.registrationCode;
        newDevice.residentId = this.state.residentSelected._id;
        newDevice.residentName = this.state.residentSelected.firstName + ' ' + this.state.residentSelected.lastName;
        newDevice.residentLocation = this.state.residentSelected.zoneName;
        newDevice.residentPictureUrl = this.state.residentSelected.pictureUrl;
        newDevice.language = 'en';

        //Map the selected language to send the correct languagecode
        switch (this.state.residentSelected.preferedLanguage) {
            case 'Spanish':
                newDevice.language = 'es'
                break;
            case 'French':
                newDevice.language = 'fr'
                break;
            case 'English':
                newDevice.language = 'en'
                break;
            default:
                newDevice.language = 'en'
                break;
        }

        const stylesObj = { modalStyles: { backgroundColor: '#ffffff' }, messageClass: 'LAlertMessageStyles' };

        this.props.AddDevice(newDevice, localStorage.getItem('communityId'), stylesObj);
    };


    RenderModalContent = () => {

        return (
            <Grid>
                <Paper elevation={3} className={this.props.isRegister ? "paperLModalRegister" : "paperLModalUnregister"} square='false' color='secondary'>
                    <Grid id='menu_item_deletetion_modal' container justify='flex-start' alignItems='baseline' style={{ height: '100%' }} >
                        <Grid item container>
                            <Grid item justify='center' style={{ width: '100%' }} alignItems='center'>
                                <this.RenderTitleContainer />
                            </Grid>
                            <Grid item justify='center' alignItems='center'>
                                <this.RenderMessageContainer />
                            </Grid>
                            <Grid item container className="ModalButtonsContainer alingCenter" style={{ paddingTop: '60px' }} justify='flex-end'>
                                <this.RenderButtonsContainer />
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    };


    RenderButtonsContainer = () => {
        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={10}>
                    <Grid item container direction='row-reverse'>
                        <Grid item container className="VoiceSettingModalButtonYes skybluebtn-engage alingCenter">
                            {this.props.isRegister ?
                                <Grid id='close_repair_close_btn' item container className="alingCenter" onClick={this.props.handleSubmit(this.onSubmitHandler.bind(this))}>
                                    Register
                                </Grid>
                                :
                                <Grid id='close_repair_close_btn' item container className="alingCenter" onClick={() => this.props.OnUnregisterHandler()}>
                                    Yes, Unregister
                                </Grid>
                            }

                        </Grid>
                        <Grid item container className="VoiceSettingModalButtonCancel alingCenter">
                            <Grid id='close_repair_return_btn' item container className="alingCenter" onClick={() => this.props.OnCancelHandler()}>
                                Cancel
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        );
    };

    RenderMessageContainer = () => {
        return (
            <Grid item container className="alingCenter" direction='row'>
                <Grid item xs={this.props.isRegister ? 12 : 10} className="VoiceSubTitleModal">
                    {this.props.isRegister ?
                        <Grid container className="register_modal_content">
                            <Grid item xs={12} style={{ display: 'grid' }}>
                                <TextField
                                    id='device_registermodal_resitrationcode'
                                    autoFocus={true}
                                    label={'Registration Code'}
                                    placeholder={'Registration Code'}
                                    className='LTextField'
                                    value={this.state.registrationCode}
                                    onChange={(e) => { this.setState({ registrationCode: this.CheckForValidCaracters(e.target.value) }) }}
                                />
                            </Grid>
                            <Grid item xs={12} className='LSectionContent' style={{ display: 'grid' }}>
                                <Field
                                    showStartAdornment={true}
                                    name="SelectResident"
                                    disabled={false}
                                    maxLength={20}
                                    selected={this.state.residentSelected}
                                    optionsItemsIconsData={this.props.residentData ? this.props.residentData : []}
                                    onChangeHandler={
                                        (evet, newItem) => {
                                            if (newItem !== null && newItem !== '') {
                                                this.setState({ residentSelected: newItem });
                                                this.setState({ onErrorModalRegisteredResident: false });

                                                this.props.dispatch(change('LModalUnregisterForm', 'location', newItem.zoneName));
                                            } else {
                                                this.setState({ residentSelected: undefined });
                                                this.setState({ onErrorModalRegisteredResident: true });
                                            }
                                        }
                                    }
                                    component={LegacyRenderSelectV2}
                                    diableClear={true}
                                    idToSet="legacy_Settings_renderSelect"
                                    id='legacy_Settings_renderSelect'
                                />
                            </Grid>
                            <Grid item xs={12} style={{ display: 'grid' }}>
                                <Field
                                    name="location"
                                    label="Location"
                                    className='LTextField'
                                    isReadOnly={true}
                                    maxLength={20}
                                    component={renderLegacyTextField}
                                    id='Legacy_registration_code'
                                />
                            </Grid>

                        </Grid>
                        :
                        <Grid item className='LDeviceMessageModalStyles' >
                            Are you sure you want to unregister the resident(s)?
                        </Grid>
                    }

                </Grid>
            </Grid>
        );
    };

    RenderTitleContainer = () => {
        return (
            <>
                <Grid item container xs={12} direction='row-reverse'>
                    <div className="engage-nav VoiceTitleModal" onClick={() => this.props.OnCancelHandler()}>
                        <img
                            src='https://engage360.s3.amazonaws.com/Icons/Solidblack/circle-xmark.svg'
                            alt='close'
                            className="closeIcon"
                            height="35px"
                        />
                    </div>
                </Grid>
                <Grid item container className="alingCenter" direction='row'>
                    <Grid item xs={10} className="LMultipleDeleteModalTitle">
                        {this.props.isRegister ?
                            <Grid>Register</Grid>
                            :
                            <Grid>Unregister</Grid>
                        }
                    </Grid>
                </Grid>
            </>
        );
    }
    //#endregion

    render() {
        return (
            <main style={{}}>
                <div>
                    <this.RenderModalContent />
                </div>
            </main>
        )
    }
}

function mapStateToProps(state, dispatch) {
    let residentData = (state.residentReducer && state.residentReducer.residentData) ? state.residentReducer.residentData : [];

    if (residentData && Array.isArray(residentData)) {
        residentData = residentData.map(item => {
            return {
                ...item,
                name: `${item.firstName} ${item.lastName}`
            }
        })
    }

    return {
        residentData: residentData
    }
}


LModalUnregister = reduxForm({
    form: 'LModalUnregisterForm',
    enableReinitialize: true,
})(LModalUnregister);

export default connect(mapStateToProps, { getResidentsByCommunity, AddDevice, UnregisterResidents })(LModalUnregister);

